module.exports = __webpack_public_path__ + "img/logo-the-fives-2.5e70aa4b.svg";